import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{aboutData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{aboutData.subtitle}</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">{aboutData.intro}</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {aboutData.highlights.map((h, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70">
                <div className="text-2xl md:text-3xl font-extrabold text-primary-500">{h.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{h.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}